/* be-custom.js — Bear Essentials custom JS carried out of Dawn 9 global.js (v16 port, 2026-09-10). Loaded from layout/theme.liquid with defer. */

/* Featured Column */
document.addEventListener('DOMContentLoaded', () => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const el = entry.target;
          const animation = el.dataset.animation;
          if (animation) el.classList.add(animation);
          el.classList.remove('opacity-0');
          observer.unobserve(el);
        }
      });
    }, {
      threshold: 0.3
    });

    document.querySelectorAll('.animated').forEach(el => {
      observer.observe(el);
    });
  });

/* Hero Custom Script */
  document.addEventListener("DOMContentLoaded", function() {
    const els = document.querySelectorAll('[data-animate-on-scroll]');
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add(entry.target.getAttribute('data-animate'));
          obs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    els.forEach(el => obs.observe(el));
  });


/* Smooth-scroll real in-page targets without intercepting placeholder/app links. */
document.querySelectorAll('a[href^="#"]').forEach(link => {
  link.addEventListener('click', e => {
    const href = link.getAttribute('href');
    if (!href || href === '#' || e.defaultPrevented) return;
    let target;
    try {
      target = document.getElementById(decodeURIComponent(href.slice(1)));
    } catch (_) {
      return;
    }
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth' });
  });
});
